<template>
  <div>
    <div ref="editor" style="text-align:left"></div>
    <el-button type="primary" v-on:click="getContent">查看内容</el-button>
    <div style="height:400px">
      <el-amap
        vid="amapDemo"
        :center="center"
        :zoom="zoom"
        class="amap-demo"
        :events="events">
        <el-amap-marker
          :position="markers.position"
          :events="markers.events"
          :visible="markers.visible"
          :draggable="markers.draggable"
          vid="el-amap-marker">
        </el-amap-marker>
      </el-amap>
      <div class="toolbar">
        position: [{{ lng }}, {{ lat }}] address: {{ address }}
      </div>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
export default {
  data () {
    let self = this
    return {
      editorContent: '',
      zoom: 14,
      center: [113.549598, 22.271471],
      address: '',
      events: {
        click (e) {
          let { lng, lat } = e.lnglat
          self.lng = lng
          self.lat = lat
          self.markers.position = [self.lng, self.lat]
          // 这里通过高德 SDK 完成。
          var geocoder = new AMap.Geocoder({
            radius: 1000,
            extensions: 'all'
          })
          geocoder.getAddress([lng, lat], function (status, result) {
            if (status === 'complete' && result.info === 'OK') {
              if (result && result.regeocode) {
                self.address = result.regeocode.formattedAddress
                self.$nextTick()
              }
            }
          })
        }
      },
      lng: 0,
      lat: 0,
      markers: {
        position: [113.549598, 22.271471],
        events: {
          click: () => {
            console.log('click marker')
          },
          dragend: (e) => {
            console.log('---event---: dragend')
            this.markers[0].position = [e.lnglat.lng, e.lnglat.lat]
          }
        },
        visible: true,
        draggable: false,
        template: '<span>1</span>'
      }
    }
  },
  methods: {
    getContent: function () {
      console.log(this.editorContent)
    }
  },
  mounted () {
    var editor = new E(this.$refs.editor)
    editor.customConfig.onchange = (html) => {
      this.editorContent = html
    }
    editor.create()
  }
}
</script>

<style lang="scss">
.amap-demo {
  height: 300px;
}
</style>
